module.exports = __webpack_public_path__ + "static/img/KV@3x.4ae1e28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/KV@3x.png
// module id = hZOg
// module chunks = 1